import React from "react";

import { Container } from "@mui/material";
import MerchantList from "../components/deposit/MerchantList";
import HeaderHelpPage from "../components/HeaderHelpPage";

const Deposit = () => {

  return (
    <>
      <Container>
        <HeaderHelpPage title="Security Deposit" description="Review security deposit and reverses held for each merchant" />
        <MerchantList />
      </Container>
    </>
  );
};

export default Deposit;
